var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdexIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 21.9286L0.434028 22.4866L2.77778 25.5H21.3369H22.2222L25 21.9286L18.0556 13L24.566 4.62946L25 4.07143L22.2222 0.5H2.77778L2.33513 1.06913L0 4.07143L6.94444 13L0 21.9286ZM8.37426 20.1429C7.79234 20.1429 7.465 19.4736 7.82227 19.0142L9.72222 16.5714L12.5 20.1429H8.37426ZM17.6129 12.4309L23.6807 4.62946H12.4388C12.0751 4.62946 11.8705 5.04777 12.0938 5.33486L12.5 5.85714H16.6257C17.2077 5.85714 17.535 6.52643 17.1777 6.98577L15.2778 9.42857L17.6129 12.4309ZM0.885299 4.07143L14.5614 21.655L14.6596 21.7812C14.8829 22.0683 14.6783 22.4866 14.3146 22.4866H13.8889H1.31933L3.22905 24.942H20.9029L2.77778 1.63824L0.885299 4.07143Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdexIconWhite);
export default __webpack_public_path__ + "static/media/IDEX-icon-white.69ca552545150349c2bf464ce309d095.svg";
export { ForwardRef as ReactComponent };